// packages
import 'intersection-observer';
import yall from 'yall-js';
import _ from 'underscore';
import Scroller from '@newswire/scroller';

// local imports
import { AdLoader } from './ads/loader';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Write your code!
var w = window.innerWidth;

function loadJsonScript(elementId, reviver) {
  const element = document.getElementById(elementId);
  if (element && element.getAttribute('type') === 'application/json') {
    return JSON.parse(element.textContent, reviver);
  } else {
    return null;
  }
}

var mydata = loadJsonScript('county-timeseries');
var closuresData = loadJsonScript('timeline-cards');

if (w > 767) {
  var divheight = window.innerHeight * 0.6;
} else {
  var divheight = window.innerHeight * 0.7;
}
var bars = mydata.reverse();

//get max of new confirmed_cases
var c_cases = _.map(_.pluck(bars, 'confirmed_cases'), function (num) {
  return num * 1;
});

var maxval = _.max(c_cases);
var barWidth = w / bars.length;

//make bar shells
for (var i = 0; i < bars.length; i++) {
  var heightpct = bars[i].confirmed_cases / maxval;
  $('#chart_wrapper').append(
    "<div class='bar'><div class='indiv_bar' id='bar_" +
      i +
      "' data-index='" +
      i +
      "'data-height='" +
      divheight * heightpct +
      "'></div></div>"
  );
}
//set width of bars
var barPct = (barWidth / w) * 100;
$('.bar').css('width', barPct + '%');

//taking a stab at animating this
var duration = 200;

// Create new IntersectionObserver
const tlview = document.querySelectorAll('.tl_info');

$('.card_chart').each(function (item, object) {
  if (item == 0) {
    var prevCard = 0;
  } else {
    var prevCard = item - 1;
  }

  var prevDate = $('#bars_' + prevCard).attr('data_value');
  var currentDate = $(this).attr('data_value');

  var prevDateIndex = _.findIndex(bars, { date: prevDate });
  var currentDateIndex = _.findIndex(bars, { date: currentDate });
  // var prevDate = $(this)
  for (var i = 0; i < prevDateIndex; i++) {
    var heightpct = bars[i].confirmed_cases / maxval;
    var barHeight = heightpct * divheight;
    if (barHeight <= 1) {
      barHeight = 1;
    } else {
      barHeight = barHeight;
    }
    $(this).append(
      "<div class='mobile_bar'><div class='indiv_bar_new' style='height: " +
        barHeight +
        "px'></div></div>"
    );
  }
  //append bars to animate
  for (var j = prevDateIndex; j < currentDateIndex; j++) {
    var heightpct = bars[j].confirmed_cases / maxval;
    var barHeight = heightpct * divheight;
    if (barHeight <= 1) {
      barHeight = 1;
    } else {
      barHeight = barHeight;
    }
    $(this).append(
      "<div class='mobile_bar newgroup'><div class='indiv_bar_new bargroup_" +
        item +
        " animating_bar' data-height=" +
        barHeight +
        '></div></div>'
    );
  }
});

$('.mobile_bar').css('width', barPct + '%');

const scroller = new Scroller({
  scenes: document.querySelectorAll('.tl_info'),
  offset: 0,
});

// the `enter` event is triggered every time a scene crosses the threshold
scroller.on('scene:enter', (d) => {
  d.element.classList.add('active');

  var endDate = d.element.attributes[1].value;
  var currentCard = d.element.attributes[2].value;
  //
  var cardId = d.element.attributes[2].value;
  var prevCard = d.element.attributes[2].value - 1;
  //
  var prevDate = $('#card_' + prevCard).attr('data_value');
  //
  //set first index to 0 for bars
  var prevDateIndex;

  if (prevCard == 0) {
    prevDateIndex = 0;
  } else {
    prevDateIndex = _.findIndex(bars, { date: prevDate });
  }

  var currentDateIndex = _.findIndex(bars, { date: endDate });

  $('#card_' + cardId + ' video').trigger('play');

  $('#card_' + currentCard + ' .card_chart').fadeIn();

  $('.active .card_chart .animating_bar').each(function (item) {
    var barHeight = $(this).attr('data-height');
    if (barHeight <= 1) {
      barHeight = 1;
    }
    $(this)
      .delay((item * duration) / 2)
      .animate({ height: barHeight }, duration);
  });
});

// the `exit` event is triggered every time a scene exits the threshold
scroller.on('scene:exit', (d) => {
  d.element.classList.remove('active');
  $('#card_' + d.index + ' video').trigger('pause');
  // $('.card_chart .animating_bar').css("height","0");
  $(
    $('.bargroup_' + d.index)
      .get()
      .reverse()
  ).each(function (item) {
    $(this)
      .delay((item * 100) / 2)
      .animate({ height: 0 }, 100);
  });
});

scroller.on('init', () => {
  // console.log('Everything is ready to go!');
});

// starts up the IntersectionObserver
scroller.init();

// const observer = new IntersectionObserver((entries) => {
//   entries.forEach((entry) => {
//     var endDate = entry.target.attributes[1].value;
//     var currentCard = entry.target.attributes[2].value;
//
//     var cardId = entry.target.attributes[2].value;
//     var prevCard = entry.target.attributes[2].value - 1;
//
//     var prevDate = $('#card_' + prevCard).attr('data_value');
//
//     //set first index to 0 for bars
//     var prevDateIndex;
//
//     if (prevCard == 0) {
//       prevDateIndex = 0;
//     } else {
//       prevDateIndex = _.findIndex(bars, { date: prevDate });
//     }
//
//     var currentDateIndex = _.findIndex(bars, { date: endDate });
//
//     if (entry.intersectionRatio > 0) {
//       //play videos
//       $('#card_' + cardId + ' video').trigger('play');
//
//       $('#card_' + currentCard + ' .card_chart').fadeIn();
//       $('.bargroup_' + currentCard).each(function (item) {
//         var barHeight = $(this).attr('data-height');
//         if (barHeight <= 1) {
//           barHeight = 1;
//         }
//         $(this)
//           .delay((item * duration) / 2)
//           .animate({ height: barHeight }, duration);
//       });
//     }
//     // now when it's out of view
//     else {
//       $('#card_' + cardId + ' video').trigger('pause');
//       $('.bargroup_' + currentCard).each(function (item) {
//         $(this)
//           .delay((item * duration) / 2)
//           .animate({ height: 0 }, duration);
//       });
//     }
//   });
// });

// tlview.forEach((div) => {
//   observer.observe(div);
// });

document.addEventListener('DOMContentLoaded', yall);
